import React, { Component } from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import './TotalTables.css';
import {
  getCurrentInvoice,
  getEdit,
  getForm,
  getInvalidFields,
  getValidationMessage,
} from 'selectors/admin/invoices/invoices';
import {
  addFormMiscCost,
  removeFormMiscCost,
  updateFormAttributeChange,
  updateFormItemLineChange,
} from 'actions/admin/invoices/invoices';
import SimpleTable from 'components/shared/table/SimpleTable';
import Number from 'components/shared/text/Number';
import { getCurrentUser } from 'selectors/authentication';
import { TYPES, usersUtil } from 'services/utils/users-util';
import Input from 'components/shared/input/Input';
import AdditionalCostsEditor from 'components/admin/invoices/AdditionalCostsEditor';

class TotalTables extends Component {
  constructor(props) {
    super(props);

    this.isClient = usersUtil.hasType(this.props.currentUser, TYPES.CLIENT);
  }

  render() {
    const lineItemTasks = this.props.currentInvoice.line_items.filter(
      (li) => li.type === 'LineItemTask'
    );
    const lineItemChangeOrders = this.props.currentInvoice.line_items.filter(
      (li) => li.type === 'LineItemChangeOrder'
    );
    return (
      <div className="table-container">
        <SimpleTable
          className={'tasks-table' + (this.isClient ? '' : ' with-contractor')}
          headers={[].concat(
            'TASK #',
            'TASK NAME',
            this.isClient ? 'COST' : ['CONTRACTOR', 'COST']
          )}
          rows={this.mapLineItems(lineItemTasks)}
          emptyMessage="No Items"
          showBottomLine={true}
        />

        {lineItemChangeOrders.length > 0 && (
          <div>
            <div className="h4 change-orders-table-title">CHANGE ORDERS</div>
            <SimpleTable
              className={
                'change-orders-table' +
                (this.isClient ? '' : ' with-contractor')
              }
              headers={[].concat(
                'TASK #',
                'CO #',
                'DETAILS',
                this.isClient ? 'COST' : ['CONTRACTOR', 'COST']
              )}
              rows={this.mapLineItems(lineItemChangeOrders)}
              emptyMessage="No Items"
              showBottomLine={true}
            />
          </div>
        )}

        <SimpleTable
          className={'total-table' + (this.isClient ? '' : ' with-contractor')}
          rows={[].concat(
            [
              [
                '',
                <span className="h4">SUB TOTAL</span>,
                <Number
                  className="h4"
                  value={this.calculateSubTotal(this.isClient)}
                  format="$0,0"
                />,
              ],
            ],
            [
              this.props.currentInvoice.deposit !== null &&
              this.props.currentInvoice.deposit !== undefined
                ? [
                    '',
                    <span className="h4">PAID DEPOSIT</span>,
                    <Number
                      className="h4"
                      value={-this.props.currentInvoice.deposit.cost}
                      format="$0,0"
                    />,
                  ]
                : [],
            ]
          )}
        />
        {this.renderAdditionalCostsTable()}
        {this.props.edit && (
          <div className="additional-costs-container">
            <div className="text-uppercase h4">additional costs</div>
            <AdditionalCostsEditor
              adjustmentDesc={this.props.form.adjustmentDesc}
              adjustment={this.props.form.adjustment}
              miscItems={this.props.form.miscCosts}
              sign={this.props.form.adjustmentSign}
              onAdjustmentDescChange={this.handleAdjustmentDescChange}
              onAdjustmentChange={this.handleAdjustmentChange}
              onAdjustmentSignChange={this.handleAdjustmentSignChange}
              onMiscAdd={this.handleMiscAdd}
              onMiscDelete={this.handleMiscDelete}
            />
          </div>
        )}
        <SimpleTable
          className={'total-table' + (this.isClient ? '' : ' with-contractor')}
          rows={[
            [
              '',
              <span className="total">TOTAL</span>,
              <Number
                className="h3"
                value={this.calculateTotal()}
                format="$0,0"
              />,
            ],
          ]}
        />

        {this.props.validationMessage !== '' && (
          <div className="invalid-message">{this.props.validationMessage}</div>
        )}
      </div>
    );
  }

  renderAdditionalCostsTable() {
    const rows = [];

    this.props.currentInvoice.misc_items.forEach((miscItem) => {
      rows.push([
        <span className="h4">{miscItem.description}</span>,
        <Number value={miscItem.cost} format="$0,0" />,
      ]);
    });

    const adjustmentValue = numeral(
      this.props.currentInvoice.adjustment
    ).value();
    if (adjustmentValue !== 0) {
      rows.push([
        <span className="h4">
          {this.props.form.adjustmentDesc || 'Adjustment'}
        </span>,
        <Number value={adjustmentValue} format="$0,0" />,
      ]);
    }
    return (
      this.showAdditionalCostsTable() && (
        <SimpleTable
          className={
            'additional-costs-table' + (this.isClient ? '' : ' with-contractor')
          }
          headers={['ADDITIONAL COSTS', 'COST']}
          rows={rows}
          showBottomLine={true}
        />
      )
    );
  }

  mapLineItems = (lineItems) => {
    return lineItems
      .sort((li1, li2) => li1.task.number - li2.task.number)
      .map((item) => {
        return [].concat(
          item.type === 'LineItemTask' ? (
            <Number value={item.task.number} format="00" />
          ) : (
            [
              <Number value={item.task.number} format="00" />,
              <Number value={item.change_order_task.number} format="00" />,
            ]
          ),
          <span className="h4">
            {item.type === 'LineItemTask'
              ? item.task.name || 'N/A'
              : item.change_order_task.description}
          </span>,
          this.isClient ? (
            <Number
              value={
                Math.round(this.props.form.amountsByLineItemId[item.id]) +
                Math.round(this.props.form.additionalCostsByLineItemId[item.id])
              }
              format="$0,0"
            />
          ) : (
            [
              <span className="h4">{item.contractor_name}</span>,
              this.props.edit ? (
                <Input
                  valid={
                    this.props.invalidFields.find(
                      (element) => numeral(element).value() === item.id
                    ) === undefined
                  }
                  value={this.props.form.amountsByLineItemId[item.id]}
                  onChange={this.handleItemLineChange.bind(this, item.id)}
                />
              ) : (
                <Number
                  value={this.props.form.amountsByLineItemId[item.id]}
                  format="$0,0"
                />
              ),
            ]
          )
        );
      });
  };

  calculateSubTotal(addAdditionalCosts) {
    return this.props.currentInvoice.line_items.reduce(
      (accumulator, currentItem) => {
        let value = 0;
        if (addAdditionalCosts) {
          value =
            Math.round(this.props.form.amountsByLineItemId[currentItem.id]) +
            Math.round(
              this.props.form.additionalCostsByLineItemId[currentItem.id]
            );
        } else {
          value = numeral(
            this.props.form.amountsByLineItemId[currentItem.id]
          ).value();
        }
        return accumulator + value;
      },
      0
    );
  }

  calculateTotal() {
    if (!this.props.edit) {
      return this.props.currentInvoice.total_cost;
    } else {
      const miscItemsTotal = this.props.form.miscCosts.reduce(
        (accumulator, currentMisc) => {
          return accumulator + numeral(currentMisc.cost).value();
        },
        0
      );
      return (
        this.calculateSubTotal(true) +
        numeral(this.props.form.adjustment).value() +
        miscItemsTotal
      );
    }
  }

  handleAdjustmentDescChange = (value) => {
    this.props.dispatch(updateFormAttributeChange('adjustmentDesc', value));
  };

  handleAdjustmentChange = (value) => {
    this.props.dispatch(updateFormAttributeChange('adjustment', value));
  };

  handleAdjustmentSignChange = (value) => {
    this.props.dispatch(updateFormAttributeChange('adjustmentSign', value));
    // Update value with the new sign
    const newAdjustmentValue = Math.abs(this.props.form.adjustment) * value;
    this.props.dispatch(
      updateFormAttributeChange('adjustment', newAdjustmentValue.toString())
    );
  };

  handleFormAttributeChange = (attribute, value) => {
    this.props.dispatch(updateFormAttributeChange(attribute, value));
  };

  handleItemLineChange = (itemId, value) => {
    this.props.dispatch(updateFormItemLineChange(itemId, value));
  };

  handleMiscAdd = (description, cost) => {
    this.props.dispatch(addFormMiscCost(0, description, cost));
  };

  handleMiscDelete = (id, index) => {
    this.props.dispatch(removeFormMiscCost(index));
  };

  showAdditionalCostsTable() {
    return (
      !this.props.edit &&
      (numeral(this.props.currentInvoice.adjustment).value() !== 0 ||
        this.props.currentInvoice.misc_items.length > 0)
    );
  }
}

export default connect((state) => {
  return {
    currentInvoice: getCurrentInvoice(state),
    currentUser: getCurrentUser(state),
    edit: getEdit(state),
    form: getForm(state),
    invalidFields: getInvalidFields(state),
    validationMessage: getValidationMessage(state),
  };
})(TotalTables);



// WEBPACK FOOTER //
// ./src/components/admin/invoices/TotalTables.js